"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _useProductListFiltersServiceCall = _interopRequireDefault(require("./useProductListFiltersServiceCall"));

/* eslint-disable no-console */
//
function useProductListFilters(path) {
  var _React$useState = _react.default.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      filterFields = _React$useState2[0],
      setfilterFields = _React$useState2[1];

  var apiCall = (0, _useProductListFiltersServiceCall.default)([]);

  _react.default.useEffect(function () {
    apiCall({
      path: path
    }).then(function (r) {
      // console.log('rrr', r);
      setfilterFields(r || []);
    }).catch(function (e) {
      console.log(e); // setFilterOptions({});
    });
  }, [apiCall, path]);

  return filterFields;
}

var _default = useProductListFilters;
exports.default = _default;